module.exports = __webpack_public_path__ + "static/media/PM117.b6c6fbd2.png";